import { useEffect, useState } from "react";

// Slim top progress bar that fills as the client scrolls the document.
export default function ScrollProgress() {
  const [pct, setPct] = useState(0);
  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement;
      const max = h.scrollHeight - h.clientHeight;
      setPct(max > 0 ? Math.min(100, Math.max(0, (h.scrollTop / max) * 100)) : 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => { window.removeEventListener("scroll", onScroll); window.removeEventListener("resize", onScroll); };
  }, []);
  return (
    <div className="fixed top-0 inset-x-0 z-40 h-1 pointer-events-none" data-testid="scroll-progress">
      <div className="h-full bg-cass-teal transition-[width] duration-150 ease-out" style={{ width: `${pct}%` }} data-testid="scroll-progress-fill" />
    </div>
  );
}
